import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Image } from '@thd-olt-component-react/image';

const HeroImage = (props) => {
  const { options } = props;
  let imageBackground = options.backgroundImage ? options.backgroundImage : '';
  imageBackground = imageBackground.replace(/^url\(['"]?([^'"]+)['"]?\)/, '$1');
  if (options.URL) {
    return (
      <a
        className={classNames({
          triggerOverlay: options.openInModal,
          'tip-Opener': options.isToolTip
        })}
        data-overlay-type={options.relationship}
        data-tooltop={(options.isToolTip) ? options.URL : ''}
        href={options.URL}
        target={(options.targetBlank) ? '_blank' : ''}
        rel={(options.externalLink) ? 'nofollow' : ''}
      >
        <Image
          stretchy
          src={imageBackground}
          id={options.name}
          alt={options.alt}
        />
      </a>
    );
  }
  return (
    <Image
      stretchy
      src={imageBackground}
      id={options.name}
      alt={options.alt}
    />
  );
};

HeroImage.propTypes = {
  options: PropTypes.shape({
    textShadowNone: PropTypes.bool,
    backgroundImage: PropTypes.string,
    name: PropTypes.string,
    alt: PropTypes.string,
    isToolTip: PropTypes.bool,
    URL: PropTypes.string,
    openInModal: PropTypes.bool,
    targetBlank: PropTypes.bool,
    externalLink: PropTypes.bool,
    relationship: PropTypes.string,
  }).isRequired
};

export default HeroImage;
